$.fn.Tags = function() {
  let self = this

	self.find('button').click(function() {
		self.toggleClass('--open')
		event.preventDefault();
		return false;
	})

	$('body').click(function(event) {
		if ($(event.target).closest('div[class*=__details]').length == 0) {
			self.removeClass('--open')
		}
	})

	self.adjust = function() {
		self.top = self.position().top
		self.find('br').remove()
		self.removeClass('--activated')
		self.removeClass('--open')

    var total_width = 0;

		self.find('span').each(function() {
			if (($(this).position().top - self.top) > 25) {
				$(this).before("<br/>");
				self.addClass('--activated')
        self.css('--max-width', total_width + 'px');
				return false;
			}
      total_width += $(this).outerWidth(true);
		})

		self.css('--max-height', self.find('div[class*=__full-wrapper]').get(0).scrollHeight + 'px')
	}

  return function() {
		$(window).on('load resize orientationchange', function() {
			self.adjust();
		})
    return self
  }()
}
